export const OPTIONS_INDEX_OFFSET = 2; // first option is placeholder. second option is the hidden option
